<template>
  <div class="haveDinnerPage">
    <van-tabs v-model="activeName">
      <van-tab title="用餐" name="haveDinner" class="haveDinner">
        <div class="haveContent">
          <p class="paddingColor"></p>
          <own-dinner></own-dinner>
        </div>
      </van-tab>
      <van-tab title="不用餐" name="noneDinner" class="haveDinner">
        <div class="haveContent">
          <p class="paddingColor"></p>
          <none-dinner></none-dinner>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
const ownDinner = () => import("@/components/haveDinner/ownDinner");
const noneDinner = () => import("@/components/haveDinner/noneDinner");
export default {
  name: "haveDinner",
  components: { ownDinner, noneDinner },
  data() {
    return {
      activeName: "haveDinner",
    };
  },
  mounted() {
    document.title = "用餐统计";
    this.setShowLoad(false);
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
<style lang="less">
.haveDinnerPage {
  width: 100%;
  height: 100%;
  .van-tabs {
    height: 100%;
  }
  .van-tabs__wrap {
    .van-tabs__nav {
      .van-tab {
        .van-tab__text {
          color: #a7a7a7;
        }
      }
      .van-tab.van-tab--active {
        .van-tab__text {
          color: #08a5ef;
        }
      }
    }
    .van-tabs__line {
      width: 65px !important;
      height: 0.5vw;
      background-color: #08a5ef;
    }
  }
  .van-tabs__content {
    height: calc(100% - 55px);
    .paddingColor {
      background-color: #f5f6f8;
      width: 100%;
      height: 10px;
      visibility: inherit !important;
    }
    .van-tab__pane {
      height: 100%;
      .haveContent {
        height: 100%;
      }
    }
  }
}
</style>